import { createSlice} from '@reduxjs/toolkit';
import { RootState } from '..';

export interface posDeviceState {
  totalRecords: number | null;
  data: [] | null | any;
  totalPages: number | null;
  currentPage: number | null;
}

const initialState: posDeviceState = {
  totalRecords: null,
  data: null,
  totalPages: null,
  currentPage: null,
};

export const posDeviceSlice = createSlice({
  name: 'posDevice',
  initialState,
  reducers: {
    setPosDevide: (state: any, action: any) => {
      state.data = action.payload.data;
      state.currentPage = action.payload.currentPage;
      state.totalPages = action.payload.totalPages;
      state.totalRecords = action.payload.totalRecords;
    },
    addNewPosDevide: (state: any, action: any) => {
      state.data = [action.payload.data, ...state.data];
    },
    reset: (state) => {
      state = initialState;
    },
  },
});

export const { setPosDevide, addNewPosDevide, reset } = posDeviceSlice.actions;
export const getPosDevice = (state: RootState) => state.posDevice.data;
console.log(getPosDevice ,"getPosDevice");
export const addPosDevice = (state: RootState) => state.posDevice.data;
export const getPosDeviceTotalRecord = (state: RootState) => state.posDevice.totalRecords;
export default posDeviceSlice.reducer;
